import { usePrevRoute } from "hooks/usePrevRoute";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { STATUS, actions as environmentActions } from "reducers/environment";

export const useBeneficiarySelectors = () => {
    const dispatch = useDispatch();
    const { beneficiariesSelectors, fetching } = useSelector((state) => state.environment);
    const [getBeneficiarySliderSelectors, setGetBeneficiarySliderSelectors] = useState(false);
    const [beneficiarySliderIsVisible, setBeneficiarySliderIsVisible] = useState(false);
    const { prevPath } = usePrevRoute();

    const closeSlide = () => {
        setBeneficiarySliderIsVisible(false);
        setGetBeneficiarySliderSelectors(false);
    };

    useEffect(() => {
        const { status: beneficiariesSelectorsStatus } = beneficiariesSelectors;
        if (getBeneficiarySliderSelectors) {
            if (beneficiariesSelectorsStatus !== STATUS.SUCCESS) {
                dispatch(environmentActions.getBeneficiariesSelectors());
            } else {
                setBeneficiarySliderIsVisible(true);
            }
        }
    }, [getBeneficiarySliderSelectors]);

    useEffect(() => {
        const { status: beneficiariesSelectorsStatus } = beneficiariesSelectors;
        if (!fetching && beneficiariesSelectorsStatus === STATUS.SUCCESS) {
            setBeneficiarySliderIsVisible(true);
        }
    }, [fetching, beneficiariesSelectors]);

    useEffect(() => {
        setTimeout(() => {
            if (prevPath === "/environment/stepDocumentation") {
                setBeneficiarySliderIsVisible(false);
            }
        }, 100);
    }, []);

    return { beneficiariesSelectors, closeSlide, beneficiarySliderIsVisible, setGetBeneficiarySliderSelectors };
};

export default useBeneficiarySelectors;
